import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./loginUser.css";
import axios from "axios";
import toast from "react-hot-toast";
import { Link } from "react-router-dom"; // ✅ added

const API_URL = process.env.REACT_APP_API_URL || "https://api.transtrackglobal.in";


export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // ✅ added

  const generateCaptcha = () => {
    const random = Math.random().toString(36).substring(2, 7).toUpperCase();
    setCaptcha(random);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const navigate = useNavigate();
  const validateForm = () => {
    if (!username || !password || !captchaInput) return false;
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      alert("Please fill all fields");
      return;
    }

    if (captchaInput !== captcha) {
      alert("Invalid Captcha");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(`${API_URL}/api/login`, {
        username,
        password,
      });

      const data = response.data;

      if (data.message) toast.success(data.message, { position: "top-right" });
      if (data.userType) localStorage.setItem("userType", data.userType);
      if (data.username) localStorage.setItem("username", data.username);
      if (data.token) localStorage.setItem("token", data.token); // Store JWT token
      navigate("/dashboard");
    } catch (error) {
      if (error.response?.data?.message) {
        alert(error.response.data.message);
      } else {
        alert("Server error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-3d">
      <div className="login-card-3d">
        <div className="login-logo-3d">
          <img
            src="/Transtrack_Logo_HD__NEW.webp"
            alt="App Logo"
          />
        </div>

        <h2 className="login-title-3d text-secondary">Sign In</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group-3d">
            <label>Username / Email</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username or email"
            />
          </div>

          {/* PASSWORD WITH EYE ICON */}
          <div className="form-group-3d">
            <label>Password</label>

            <div className="password-eye-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
              />

              <span
                className="password-eye"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                ></i>
              </span>
            </div>
          </div>

          <div className="form-group-3d">
            <label>Captcha</label>

            <div className="captcha-3d">
              <span className="captcha-text-3d">{captcha}</span>
              <button
                type="button"
                onClick={generateCaptcha}
                className="captcha-refresh-3d"
              >
                ↻
              </button>
            </div>

            <input
              type="text"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              placeholder="Enter captcha"
            />
          </div>

          {/* FORGOT PASSWORD */}

          <button type="submit" className="login-btn-3d" disabled={loading}>
            {loading ? "Processing..." : "Login"}
          </button>
          <div className="forgot-password ">
            <Link to="/ResetPassword">Forgot Password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
